var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 18 0 18 20 0 20"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design---Data-Copy-2",
    transform: "translate(-372.000000, -487.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(372.000000, 487.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01612908,17.2332903 C9.37160371,17.2332903 9.66238887,16.9333516 9.66238887,16.5666871 L9.66238887,7.00007738 C9.66238887,6.6334129 9.37160371,6.33347421 9.01612908,6.33347421 C8.66065446,6.33347421 8.36986929,6.6334129 8.36986929,7.00007738 L8.36986929,16.6000202 C8.36986929,16.9332325 8.66065446,17.2331712 9.01612908,17.2331712 L9.01612908,17.2332903 Z M15.3823564,4.60003214 L2.64990174,4.60003214 L3.65163615,18.6666151 L14.3805066,18.6666151 L15.3823564,4.60003214 Z M6.4308591,3.2665877 L11.6015145,3.2665877 L11.6015145,1.33326587 L6.4308591,1.33326587 L6.4308591,3.2665877 Z M18,3.93319087 C18,4.29985536 17.7091571,4.59979405 17.3536825,4.59979405 L16.6749337,4.59979405 L15.6085098,19.3663728 C15.5762517,19.6998232 15.3177247,19.9997619 14.9622501,19.9997619 L3.03769224,20 C2.71441807,20 2.42363291,19.7332754 2.39143245,19.3666109 L1.32500858,4.60003214 L0.64625979,4.60003214 C0.290785167,4.60003214 0,4.30009345 0,3.93342897 C0,3.56676448 0.290785167,3.26682579 0.64625979,3.26682579 L5.13839722,3.2665877 L5.13839722,0.666603175 C5.13839722,0.299938691 5.42918239,0 5.78465701,0 L12.247832,0 C12.6033066,0 12.8940918,0.299938691 12.8940918,0.666603175 L12.8940918,3.2665877 L17.3537402,3.2665877 C17.7092148,3.2665877 18,3.56676448 18,3.93319087 L18,3.93319087 Z M5.7845416,17.2331117 C6.14001622,17.2331117 6.43080139,16.933173 6.43080139,16.5665085 L6.43080139,6.99989881 C6.43080139,6.63323433 6.14001622,6.33329564 5.7845416,6.33329564 C5.42906698,6.33329564 5.13828181,6.63323433 5.13828181,6.99989881 L5.13828181,16.5998417 C5.13828181,16.933054 5.42906698,17.2329927 5.7845416,17.2329927 L5.7845416,17.2331117 Z M11.6013991,16.5665085 L11.6013991,6.99989881 C11.6013991,6.63323433 11.8921842,6.33329564 12.2476589,6.33329564 C12.6031335,6.33329564 12.8939187,6.63323433 12.8939187,6.99989881 L12.8939187,16.5998417 C12.8939187,16.9665062 12.6031335,17.2664448 12.2476589,17.2664448 C11.8921842,17.2662067 11.6013991,16.9329944 11.6013991,16.56633 L11.6013991,16.5665085 Z",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.868869c96189b7ea80bbb2e67a860379.svg";
export { ForwardRef as ReactComponent };